import { Link } from 'react-router-dom';
import { Container, InfoBox } from '@tryhackme/thm-ui-components';
import styled, { css } from 'styled-components';

export const StyledRoomContent = styled.div`
  position: relative;
`;

export const StyledContainer = styled(Container)<{ $isBreakdownExperimentEnabled: boolean; $isDarkMode: boolean }>`
  margin: ${({ $isBreakdownExperimentEnabled }) => ($isBreakdownExperimentEnabled ? 0 : '3rem auto')};
  ${({ $isBreakdownExperimentEnabled, $isDarkMode, theme }) =>
    $isBreakdownExperimentEnabled &&
    css`
      padding: 3rem 2.4rem 8rem 2.4rem;
      max-width: 100%;
      min-height: calc(100vh - 17rem);
      background: ${$isDarkMode ? theme.colors.background.dark : theme.colors.background.main};
      & > * {
        max-width: 80rem;
        margin: auto;
        width: 100%;
      }
    `}
`;

export const StyledInfoBox = styled(InfoBox)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 3rem;

  p > a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const StyledVideoSection = styled.div`
  flex: 1;
  padding: 3rem;
  background-color: ${({ theme }) => theme.colors.background.main};
  margin-bottom: 3rem;
  border-radius: ${({ theme }) => theme.radius.small};
  overflow-x: auto;
  box-sizing: border-box;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 3rem 1.8rem;
  }
`;

export const SocSimAdContainer = styled.div`
  margin: 3.2rem 0 4.8rem;
`;

export const AlertBannerContainer = styled.div`
  margin: 0.8rem 0;
`;
export const StyledLink = styled(Link)`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  text-decoration: none;
`;
